/* ***************************************
This mixin "exposes" the methods:
  * scrollResultsWindow() [for NikudResultsContainer and NikudEdit]
  * moveToNextWord() [for ManualNikudPane (&KeyMap), NikudOptionsPane, EditNikudPane, and NikudEdit]
  * moveToPreviousWord() [for ManualNikudPane and NikudEdit]
  * moveToWordMethod() [for NikudResultsContainer and NikudEdit]
(all else should be considered "internal")
*************************************** */

import scrollParentToChild from '../js/scrollParentToChild'

export default {
  name: 'navigationMixins',
  methods: {
    scrollResultsWindow () {
      const resultsWindow = document.getElementsByClassName('main-results-box')[0]
      const currentWordIndex = this.$store.state.currentPositionData.wordIndex
      if (currentWordIndex < resultsWindow.children.item(0).children.length) scrollParentToChild(resultsWindow, 
        resultsWindow.children.item(0).children.item(currentWordIndex), 'extraPx=8') // lineHeight - span height
    },
    moveToNextWord (mode = 'auto') {
      const currentWordIndex = this.$store.state.currentPositionData.wordIndex
      const currentWordObj = currentWordIndex >= 0 // if index = -1 then currentWordObj = null
                              ? this.$store.state.allWorkingNikud.wordsArray[currentWordIndex] : null
      const newWordIndex = currentWordObj // if positioned IN a sepBefore, just auto-jump OUT of it
        && this.$store.state.currentPositionData.letterIndex < currentWordObj.sepBefore.length && mode === 'auto'
          ? currentWordIndex : currentWordIndex + 1
      if (newWordIndex < this.$store.state.allWorkingNikud.wordsArray.length) {
        this.$store.commit('SET_WORD_AND_LETTER', {
          word: newWordIndex,
          letter: mode === 'auto'
            ? this.$store.state.allWorkingNikud.wordsArray[newWordIndex].sepBefore.length
            : 0
        })
        this.scrollResultsWindow()
      }
    },
    moveToPreviousWord (mode = 'auto') {
      const currentWordIndex = this.$store.state.currentPositionData.wordIndex
      if (currentWordIndex > 0) {
        const previousWord = this.$store.state.allWorkingNikud.wordsArray[currentWordIndex - 1]
        this.$store.commit('SET_WORD_AND_LETTER', {
          word: currentWordIndex - 1,
          letter: mode === 'auto' ? previousWord.sepBefore.length : previousWord.sepBefore.length 
                                                                    + previousWord.standardLetterArray.length 
                                                                    + previousWord.sepAfter.length - 1
        })
        this.scrollResultsWindow()
      }
    },
    moveAfterEditingWordGroupIfNeeded () {
      const needToMove = (this.localCurrentWord 
        && this.localCurrentLetterIndex >= (this.localCurrentWord.sepBefore.length 
                                            + this.localCurrentWord.standardLetterArray.length 
                                            + this.localCurrentWord.sepAfter.length - 1))
      if (needToMove) this.moveToNextWord()      
    },
    moveToWordMethod (wordIndex) {
      this.$store.commit('SET_WORD_AND_LETTER', {
        word: wordIndex,
        letter: this.$store.state.allWorkingNikud.wordsArray[wordIndex].sepBefore.length
      })
      this.scrollResultsWindow()
    }
  }
}
